export const defaultFeatcUsersQueryParams = {
  no_paginate: 1,
  sortBy: 'first_name',
  order: 'asc',
};
